export const cookiesAnalyticsEvents = [
  'marketingCookiesAangezet',
  'marketingCookiesUitgezet',
  'analytischeCookiesAangezet',
  'analytischeCookiesUitgezet',
] as const;
